import React, { useEffect, useState, useRef } from 'react'
import { Button, Typography } from '@material-ui/core'
import { InfoComponentProps } from './info-component.types'
import { useInfoComponentStyles } from './info-component.styles'
import { transformToMultiLine } from '../../../../utils/strings'
import { useTranslation } from 'react-i18next'
import { useScreenSize } from '../../../../hooks/use-screen-size'
import Skeleton from '@material-ui/lab/Skeleton'
import Box from '@material-ui/core/Box'

const expandableTextMinimumHeight = 404

export const InfoComponent: React.FC<InfoComponentProps> = (
  props: InfoComponentProps
) => {
  const classes = useInfoComponentStyles()
  const {
    name,
    categoryName,
    description = '',
    webSite,
    similarNonprofitsButtonHandler,
    similarNonprofits,
    loading,
  } = props

  const { t } = useTranslation()
  const screenSize = useScreenSize()
  const [isLongText, setIsLongText] = useState<boolean>(false)
  const textHolder = useRef<HTMLDivElement>(null)

  //Check Long Text
  const checkLongText = () => {
    const textHolderHeight = textHolder.current!.offsetHeight
    textHolderHeight > expandableTextMinimumHeight
      ? setIsLongText(true)
      : setIsLongText(false)
  }

  /* Use Effect Check Long Text */
  useEffect(checkLongText, [screenSize, description])

  if (loading) {
    return (
      <div className={classes.infoBlock}>
        <Box pt={0.5}>
          <Skeleton
            animation="wave"
            width="70%"
            height={40}
            style={{ marginBottom: 16 }}
          />
          <Skeleton
            animation="wave"
            width="50%"
            height={24}
            style={{ marginBottom: 8 }}
          />
          <Skeleton
            animation="wave"
            width="40%"
            height={20}
            style={{ marginBottom: 16 }}
          />
          <Skeleton
            animation="wave"
            width="100%"
            height={16}
            style={{ marginBottom: 8 }}
          />
          <Skeleton
            animation="wave"
            width="95%"
            height={16}
            style={{ marginBottom: 8 }}
          />
          <Skeleton
            animation="wave"
            width="90%"
            height={16}
            style={{ marginBottom: 8 }}
          />
          <Skeleton
            animation="wave"
            width="85%"
            height={16}
            style={{ marginBottom: 8 }}
          />
          <Skeleton
            animation="wave"
            width="30%"
            height={36}
            style={{ marginTop: 16 }}
          />
        </Box>
      </div>
    )
  }

  return (
    <div className={classes.infoBlock}>
      <Typography className={classes.name} variant="h5" component="h1">
        {name ? name : <Skeleton animation="wave" width="70%" />}
      </Typography>
      <div className={classes.detailCategoryLine}>
        <Typography
          align="left"
          variant="h6"
          component="h6"
          className={[
            classes.bold,
            classes.detailCategory,
            classes.detailCategoryLabel,
          ].join(' ')}
          title={'categoryLabel'}
        >
          {`${t('nonprofitCatalog.categoryLabel')}:`}
        </Typography>
        <Typography
          className={[
            classes.space,
            classes.detailCategory,
            classes.detailCategoryName,
          ].join(' ')}
          ref={textHolder}
          variant="body1"
          component="p"
        >
          {categoryName}
        </Typography>
      </div>
      <Typography
        className={[classes.bold, classes.descriptionLabel].join(' ')}
        variant="body1"
        component="p"
      >
        {t('nonprofitCatalog.descriptionLabel')}
      </Typography>
      {!isLongText && (
        <Typography
          className={classes.descriptionText}
          variant="body1"
          component="p"
        >
          {description
            ? transformToMultiLine(description)
            : t('nonprofitCatalog.noDescription')}
        </Typography>
      )}
      {webSite && (
        <a
          href={webSite}
          target="_blank"
          rel="noreferrer"
          style={{ display: 'block' }}
        >
          {name}
        </a>
      )}
      {similarNonprofits && (
        <Button
          onClick={similarNonprofitsButtonHandler}
          variant="text"
          className={[classes.bold, classes.similarNonprofitsButton].join(' ')}
        >
          {t('nonprofitCatalog.similarNonprofitsButton')}
        </Button>
      )}
    </div>
  )
}
